
const lowerCaseKeysObject = (obj = {}) =>
  Object.keys(obj).reduce((newObj, key) => {
    newObj[key.toLowerCase()] = obj[key];
    return newObj;
  }, {});

export class AmAsset {
  constructor(asset) {
    asset = asset || {};
    asset.session = asset.session || {};
    const attrs = lowerCaseKeysObject(asset.attrs);
    this.id = asset.equipmentId;
    this.name = asset.name;
    this.attrs = asset.attrs;
    this.make = attrs['make'];
    this.model = attrs['model'];
    this.year = attrs['model year'];
    this.keypadStatus = asset.keypadStatus;
    this.accessSession = asset.session['status'];
    this.accessOperator = asset.session['operatorName'] || '';
    this.accessLast = asset.session['last'] || '';
    this.operators = asset.operators || [];
    //to be determined for now its (pending,success,failed)
    this.codesSyncStatus = asset.status;
    this.selected = false;
  }
}
